import { IRestModel } from "ClientApp/utils/rest-api";
import { YesNoUnknown } from "../enums";
import { ICancerHistory } from "./cancer-history";
import { IDashRegistrationLog } from "./dash-registration-log";
import { IDrugUse } from "./drug-use";
import { IDrugUseHistory } from "./drug-use-history";
import { IMedicineUseHistory } from "./medicine-use-history";
import { IMicrositeRecipient } from "./microsites";
import { IPreWorkupLabDetails } from "./pre-workup-lab-details";
import { ISurgicalHistory } from "./surgical-history";
import { IGambitData } from "./gambit-data";
import { DashMicrositeMatchQuality } from "./dash-microsite-match-quality";

export interface IDonorRegistration extends IRestModel {
    id: number,
    source: string,
    centerWorkflowId: number,
    remoteStatus: number | null,
    onHoldStatusReason: string | null,
    remoteStatusDate: string | null,
    centerAlias: string,
    centerId: number,
    fullName: string,
    addressLine1: string,
    donorCity: string,
    donorState: string,
    donorPostalCode: string,
    daysPending: number,
    preWorkupLabStatus: string,
    labKitRequestId: string,
    phlebotTrackingId: string,
    isInExpertSystem: boolean,
    isExpertSystemParticipant: boolean,
    type: string,
    recipientLocation: string,
    location: string,
    milesFromCenter: number | null,
    email: string,
    phoneNumber: string,
    connectToDonorOffer: boolean,
    recipFullName: string,
    firstName: string,
    lastName: string,
    recipFirstName: string,
    recipLastName: string,
    recipDob: string,
    emailTemplate: string,
    emailSubject: string,
    donorConnectStatus: string,
    donorConnectRequested: boolean,
    donorConnectEmailSent: boolean,
    coordinatorId: number,
    coordinator: { id: number, fullName: string },
    recipientCenterCoordinator: { id: number, fullName: string },
    recipientCenterCoordinatorPhone: string,
    recipientCoordinatorId: number,
    logs: IDashRegistrationLog[],
    preWorkupLabDetails: IPreWorkupLabDetails,
    hasMicrositePatient: boolean,

    //actions list
    isNkrUser: boolean,
    labFileUploaded: boolean,
    labJsonFileUploaded: boolean,
    labUploadedDateTime: string,
    scripUploadFile: boolean,
    preWorkupLabExists: boolean,
    currentRegistrationStep: number,
    currentRegistrationStepStatus: string,
    toDoStatus: string,
    preWorkupLabStep: number,
    isRemoteDonor: boolean,
    donationType: number,
    donationTypeDesc: string,
    canAccessFollowUp: boolean,
    isReadOnly: boolean,
    donorEditKey: string,
    dashDomain: string,

    //misc
    isRepeat: boolean,
    hasFile: boolean,
    isOnHold: boolean,
    hasUsedAlcohol: boolean,

    //jug
    jugStatus: number,
    jugStatusDesc: string,
    jugTrackingNumber: string,
    jugRequestedDate: string,
    jugShippedDate: string,
    jugArrivalDate: string,

    voucherEducationChoiceId: number,
    closeLoopEntityType: number,
    closeLoopEntityTypeDescription: string,
    closeLoopEntityTypeId: number,
    closeLoopEpletMismatch: string,
    registrationDateTime: string,
    historyCompleteDateTime: string,
    dispositionRecordedDateTime: string,
    centerNextFollowUpDate: string
    closeLoopSurgeryDateTime: string
    closeLoopLinkedDonorType: number,
    disposition: string,

    cancers: ICancerHistory[],
    allergies: string[],
    surgeries: ISurgicalHistory[],
    medicines: IMedicineUseHistory[],
    isQuickStartDonor: boolean,
    remindersSent: number,
    isInEmr: boolean,
    isClosed: boolean,
    emrRegistrationstring: string,
    emrCompletestring: string,
    preliminaryReviewstring: string,
    medicalReviewstring: string,
    closedstring: string,
    closedByUserId: number,
    closedByUsername: string,
    expirestring: string,
    onHoldReason: number,
    middleInitial: string,
    preferredName: string,
    phoneNumberSecondary: string,
    emergencyContact: string,
    emergencyContactPhone: string,
    emergencyContactRelationship: string,
    referralSource: string,
    isAdp: boolean,
    isNdd: boolean,
    voucherEducationChoice: number,
    isAcceptable: boolean,
    ruleOutReasons: string,
    isCenterNotified: boolean,
    stopCommunication: boolean,
    timesCheckedIfContacted: number,
    noContactReportstring: string,
    noContactReportDetails: string,
    workupScheduledstring: string,
    workupCompletedstring: string,
    preOpScheduledstring: string,
    preOpCompletedstring: string,
    surgeryScheduledstring: string,
    surgeryCompletedstring: string,
    isSurgeryScheduleConfirmed: boolean,
    isSurgeryConfirmed: boolean,
    gender: string,
    heightInches: number,
    weightLbs: number,
    isCurrentlyIncarcerated: boolean,
    isResidingInUsa: boolean,
    isAbleToGetToUsa: boolean,
    isDonatingForCompensation: boolean,
    willAcceptTransfusions: boolean,
    hasNutcracker: string | null,
    wasNutcrackerTreated: boolean | null,
    nutcrackerTreatment: string | null,
    hasHadOrganDisease: boolean,
    hasHadHeartAttack: boolean,
    heartAttackRemissionStatus: number,
    hasDiabetes: boolean,
    diabetesStatus: string,
    hasHadCancer: boolean,
    // cancersJson: string,
    hasHadKidneyDisease: boolean,
    hasHadKidneyStones: boolean,
    kidneyStoneEpisodes: number,
    kidneyStoneRemissionStatus: string,
    kidneyStoneTreatment: string,
    hasBeenPregnant: boolean,
    isPregnant: boolean,
    monthsSincePregnant: number,
    isNursing: boolean,
    hadGestationalDiabetes: boolean,
    isPlanningOnPregnancy: boolean,
    isTakingBirthControl: boolean,
    birthControlForm: string,
    birthControlMonths: number,
    birthControlComplications: string,
    isAbleToStopBirthControl: boolean,
    preferredLanguage: string,
    isInterpreterNeeded: boolean,
    contactPreference: string,
    contactBestStartHour: string,
    contactBestEndHour: string,
    dlIssueState: number,
    city: string,
    state: number,
    postalCode: number,
    countryOfResidence: string,
    dlIssueCountry: string,
    nonUsStateProvince: string,
    dlNonUsStateProvince: string,
    ssn: string,
    ssnDecrypted: string,
    dlNumber: string,
    dlNumberDecrypted: string,
    mothersMaiden: string,
    mothersMaidenDecrypted: string,
    passportNum: string,
    passportNumDecrypted: string,
    maritalStatus: string,
    ethnicity: string,
    employmentStatus: string,
    occupation: string,
    occupationHasHeavyLifting: boolean,
    medicalPto: string,
    annualIncomeRange: number,
    wageReimbursementImportance: number,
    qualifiesForCompensation: boolean,
    wantsWageReimbursement: boolean,
    wageReimbursementStep: string,
    wageReimbursementAmount: number,
    wageReimbursementPaidDate: string,
    wageReimbursementDeclineReason: string,
    wageReimbursementReviewDueDate: string,
    wageReimbursementDocRequestDate: string,
    incomePayStubGross: number,
    incomePayStubStartDate: string,
    incomePayStubEndDate: string,
    incomeIrsYearGross: number,
    incomeIrsYear: number,
    payStubFile: string,
    taxFile: string,
    totalReimbursementCount: number,
    totalReimbursementAmount: number,
    lastReimbursementDate: string,
    currentWeeklyGrossPay: number,
    priorYearIncome: number,
    connectToDonorAcceptedDate: string,
    connectToDonorAssignedUsername: string,
    connectToDonorAssignedFirstName: string,
    connectToDonorAssignedLastName: string,
    connectToDonorMilestone: string,
    connectToDonorMentor: string,
    educationLevel: string,
    exerciseRoutine: string,
    hasHealthInsurance: boolean,
    ddRecipFirstName: string,
    ddRecipLastName: string,
    ddKnowsRecipDob: boolean,
    ddRecipDob: string,
    ddRecipUrgency: string,
    ddAlternateDonationOptions: any[],
    ddRelationshipToPatient: string,
    ddFrequencyOfCommunication: string,
    motivationToDonate: string,
    recipientCenterId: number,
    recipientCenterName: string,
    recipientCenterIsNkrParticipant: boolean,
    recipientAtSameDashCenter: number,
    recipientIsWillingToTransfer: number,
    isHardshipToTravel: number,
    isRemoteDonationPreferred: boolean,
    hasAllergies: boolean,
    // allergiesJson: string,
    hasHadSurgeries: boolean,
    // surgeriesJson: string,
    takesMedication: boolean,
    // medicinesJson: string,
    physicianName: string,
    physicianCity: string,
    physicianState: number,
    aboType: string,
    hasHistoryOfHighBp: string,
    highBpAgents: string,
    hadHighBpDuringPregnancy: string,
    hasHadCabg: string,
    hasHistoryOfBloodClots: string,
    hasHistoryOfCoronaryDisease: string,
    hasHistoryOfHighCholOrTg: string,
    hasStents: string,
    historyChestPainExercise: string,
    historyChestPainOther: string,
    resultsOfClimbingStairs: string,
    hadStressTestWithinYear: string,
    stressTestLocation: string,
    stressTestResults: string,
    hasHadStroke: string,
    howManyStrokes: number,
    hasHadLegBypass: string,
    howManyLegBypasses: number,
    historyLungDisease: string,
    hasCopd: string,
    hasTb: string,
    historyPneumonia: string,
    hasRespiratoryIssues: string,
    respiratoryIssuesDescription: string,
    hasHiv: string,
    hasGastroIssues: string,
    gastroIssuesDescription: string,
    historyGallstones: string,
    historyPancreatitis: string,
    historyLiverDisease: string,
    hasHepB: string,
    hasHepC: string,
    hasBleedingProblem: string,
    hasHadUti: string,
    utiEpisodes: number,
    utiRemissionStatus: string,
    historyKidneyDamage: string,
    historyProteinuria: string,
    historyHematuria: string,
    historyNeuroDisease: string,
    historySeizure: string,
    hasLupus: string,
    historyParalysis: string,
    hasArthritis: string,
    historyNeuropathy: string,
    historyDepression: string,
    historyAnxiety: string,
    hasHistoryOfPsychiatric: string,
    psychiatricDescription: string,
    historyFibroidUterus: string,
    historyEndometriosis: string,
    historyPolycysticOvaries: string,
    hasHadMiscarriages: string,
    howManyMiscarriages: number,
    hadLateMiscarriage: boolean,
    hasHadAbortions: string,
    howManyAbortions: number,
    hasReceivedTransfusion: string,
    howManyTransfusions: number,
    hasHistoryOfObesity: string,
    hasFabrys: string,
    hasSickleCell: string,
    hasSickleCellTrait: string,
    hasSarcoidosis: string,
    hasAutoImmune: string,
    autoImmuneDescription: string,
    lastPhysicalExam: string,
    hasHadPhysicalExam: string,
    physicalExamYearsAgo: number,
    lastMammogram: string,
    hasHadMammogram: string,
    mammogramYearsAgo: number,
    lastPapSmear: string,
    hasHadPapSmear: string,
    papSmearYearsAgo: number,
    lastPsaTest: string,
    hasHadPsaTest: string,
    psaTestYearsAgo: number,
    hasHadColonoscopy: string,
    additionalComments: string,
    visibilityComments: string,
    isTbActive: boolean,
    isHepBActive: boolean,
    familyHistoryKidneyDisease: string,
    familyMembersKidneyDisease: string,
    familyHistoryLiverDisease: string,
    familyMembersLiverDisease: string,
    familyHistoryHeartDisease: string,
    familyMembersHeartDisease: string,
    familyHistoryCad: string,
    familyMembersCad: string,
    familyHistoryBloodPressure: string,
    familyMembersBloodPressure: string,
    familyHistoryBloodDisorder: string,
    familyMembersBloodDisorder: string,
    familyHistoryCancer: string,
    familyMembersCancer: string,
    familyHistoryKidneyCancer: string,
    familyMembersKidneyCancer: string,
    familyHistoryDiabetes: string,
    familyMembersDiabetes: string,
    isMotherAlive: string,
    mothersLastAge: number,
    motherCauseOfDeath: string,
    isFatherAlive: string,
    fathersLastAge: number,
    fatherCauseOfDeath: string,
    howManySiblings: number,
    howManyAdultChildren: number,
    howManyUnderAgeChildren: number,
    usesAlcohol: boolean,
    alcoholDrinks: number,
    alcoholFrequency: string,
    hasAbusedAlcohol: boolean,
    hasUsedTobacco: boolean,
    tobaccoYears: number,
    usesTobacco: boolean,
    willStopTobaccoUse: boolean,
    tobaccoPacks: number,
    tobaccoFrequency: string,
    drugUse: string,
    hasUsedDrugs: boolean,
    hasBeenTreatedForDrugAbuse: boolean,
    // drugsUsedJson: string,
    // drugUseHistoryJson: string,
    drugUseHistory: IDrugUseHistory[];
    drugsUsed: IDrugUse[];
    hasHadLegalIssues: boolean,
    hasBeenSentencedToPrison: boolean,
    prisonWhenAndWhere: string,
    hasTraveledLastYear: boolean,
    travelLocations: string,
    hasHadHighRiskSex: boolean,
    hasHadSexWithMmRelationsMale: boolean,
    hasHadMmSex: boolean,
    hasHadSexWithProstitute: boolean,
    hasProstituted: boolean,
    hasHadSexWithNeedleDrugUser: boolean,
    hasUsedNeedleDrugs: boolean,
    hasBeenInJailOver72: boolean,
    hasHadStd: boolean,
    hasBeenOnHemodialysis: boolean,
    hasHadSuicidalThoughtsAttempts: boolean,
    remoteCenterId: number,
    expireDateTime: string,
    age: number,
    stateProvinceString: string,
    bmi: number,
    donorSituation: string,
    surveyNeededReimbursement: number,
    birthDate: string,
    micrositeRecipient: IMicrositeRecipient,
    remoteTransferType: string,
    closedDateTime: string,
    recipientCenterAlias: string,
    colonoscopyYearsAgo: number,

    surgeryScheduledDateTime: string,
    reviewComments: string,
    donorStateId: number,
    dispositionId: number,

    hasHlaAlleleTyping: boolean,
    isExpertSystem: boolean,
    preWorkupLabStartDate: string,

    isLinkedToDonor: boolean,
    linkedDonorId?: number,
    linkedDonorWatrCenterId?: number,
    wageAndTravelRequested?: boolean,
    linkedDonorWatrRequestId?: number,
    linkedDonorWatrStatus?: number,
    donorShieldInvitePendingWorkup?: boolean,
    donorShieldAdvancedReimbursementReady?: boolean,
    isInvitedToDonorShield?: boolean,
    isInvitedToAdvancedReimbursement?: boolean,
    donorShieldInvitationSentDate?: string
    isInternationallyEligible?: boolean | null,
    countryOfResidenceId?: number | null,
    isDcnParticipant?: boolean,
    // Gambit Data
    dashGambitData: IGambitData[],
    micrositeMatchQuality: DashMicrositeMatchQuality
}
